import { Version } from "api"
import { AxiosResponse } from "axios"
import { useApiClient } from "./useApiClient"

export const useStatusApi = () => {
    const apiClient = useApiClient()
  
    const getVersion = () => {
      return apiClient.request<void, AxiosResponse<Version>>({
        url: `api/status/version`,
        method: 'get',
        withCredentials: false,
      })
    }
  
    return {
      getVersion
    }
  }
  